// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cR9zhnbdhgknlC {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  background-color: var(--ds-background-neutral-bold, #44546f);
  color: var(--ds-text-inverse, #ffffff);
}
.TeYZ5IBxW09c5b {
  position: relative;
  text-align: center;
}
.uGKeC9z9o2V8BW {
  position: relative;
  top: 2px;
  margin: 4px 8px 0 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `cR9zhnbdhgknlC`,
	"text": `TeYZ5IBxW09c5b`,
	"icon": `uGKeC9z9o2V8BW`
};
export default ___CSS_LOADER_EXPORT___;
